import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7711cd0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex",
  ref: "menu"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/arrow-left.svg" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  ref: "menuItems",
  class: "menu_wrapper"
}
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "menu_item_text" }
const _hoisted_8 = {
  key: 0,
  class: "menu_item_badge menu_item_badge_number"
}
const _hoisted_9 = {
  key: 1,
  class: "menu_item_badge menu_item_badge_alert"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/arrow-right.svg" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "scroll_button scroll_button_left",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickLeftButton && _ctx.clickLeftButton(...args)))
    }, _hoisted_3, 512), [
      [_vShow, _ctx.isShowLeftArrow]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(tab.url == _ctx.modelValue.url ? 'menu_item active' : 'menu_item'),
            key: tab.url,
            onClick: ($event: any) => (_ctx.click(tab))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(tab.text)), 1),
            (_ctx.getBadge(tab)?.type === 'number' && _ctx.getBadge(tab)?.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getBadge(tab).value > 9 ? '9+' : _ctx.getBadge(tab).value), 1))
              : _createCommentVNode("", true),
            (_ctx.getBadge(tab)?.type === 'alert')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " ! "))
              : _createCommentVNode("", true)
          ], 10, _hoisted_6))
        }), 128))
      ])
    ], 512),
    _withDirectives(_createElementVNode("div", {
      class: "scroll_button scroll_button_right",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickRightButton && _ctx.clickRightButton(...args)))
    }, _hoisted_11, 512), [
      [_vShow, _ctx.isShowRightArrow]
    ])
  ], 512))
}